
import { mapState, mapMutations, mapActions } from 'vuex'

import { SingleSignOn } from '@/components';
import SigninHeader from '@pleinair/bigcolony-vue/components/account/signin/SigninHeader.vue';
import CustomSigninForm from '@/components/account/CustomSigninForm.vue';
import CustomVerifyCodeForm from '~/components/account/CustomVerifyCodeForm.vue';
import CustomCodeEntryForm from '~/components/account/CustomCodeEntryForm.vue';
import AccountAlert from '@pleinair/bigcolony-vue/components/account/default/elements/AccountAlert.vue'

export default {
  name: 'SigninViewDefault',
  components: {
    CustomSigninForm,
    CustomVerifyCodeForm,
    SigninHeader,
    SingleSignOn,
    AccountAlert,
    CustomCodeEntryForm
  },
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          provider: 'olo',
          placement: 'account',
          forgot_placement: 'below',
          forgot_text: 'Forgot Password?',
          signin_text: 'Sign In',
          submit_icon: false,
          component_animation: 'animate__animated animate__fadeInUp',
          background_animation: '',
          form_animation: '',
          sign_header: {
            title: 'Sign In',
            navLinks: [{ route: '/account/signup', name: 'Create a New Account', }],
            helper: 'New here?',
            icon: {},
          },
          account_alert: null,
        }
      }
    },
    onEvent: {
      type: Function,
      default: () => {}
    },
    blok: {},
  },
  data() {
    return {
      form: true,
      verify: false,
      code: false,
      form_data: {}
    }
  },
  computed: {
    backgroundMobileImg() {
      if (this.blok && this.blok['mobile_bg_img'] && this.blok['mobile_bg_img'].filename) {
        return { 'background-image': `url('${this.blok['mobile_bg_img'].filename}')` }
      }

      return {}
    },
    backgroundDesktopImg() {
      if (this.blok && this.blok['desktop_bg_img'] && this.blok['desktop_bg_img'].filename) {
        return { 'background-image': `url('${this.blok['desktop_bg_img'].filename}')` }
      }

      return {}
    },
  },
  methods: {
    ...mapMutations([ 'setLoading', 'setErrors', 'setToken', 'setUser' ]),
    ...mapMutations({
      setGuestUser: 'checkout/setGuestUser'
    }),
    ...mapActions([ 'sendRequest' ]),
    handleSignInSuccess(data) {
      this.form_data = data
      this.form = false
      this.verify = true
    },
    handleVerifySuccess(data) {
      this.form_data = data
      this.verify = false
      this.code = true
    }
  }
}
